import { Record } from 'immutable';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  payments: null,
  latestRequestDate: {},
  paymentCalcInProgress: {},
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

const getLatestRequestDate = (latestRequestDate, deskingOfferId) =>
  latestRequestDate[deskingOfferId];

const setLatestRequestDate = (latestRequestDate, deskingOfferIds, date) => {
  deskingOfferIds.forEach(deskingOfferId => {
    latestRequestDate[deskingOfferId] = date;
  });
  return { ...latestRequestDate };
};

const updateWithPayment = (payments, newPaymentForOffer) => {
  const { deskingOfferId, ...newPayment } = newPaymentForOffer;
  const oldPayments = payments.filter(
    item => item.deskingOfferId !== deskingOfferId,
  );
  return [...oldPayments, { deskingOfferId, payment: newPayment }];
};

const deletePayment = (payments, deletedDeskingOfferId) =>
  payments.filter(item => item.deskingOfferId !== deletedDeskingOfferId);

const addRequestInProgress = (
  paymentCalcInProgress,
  deskingOfferIds = [] /* string[] */,
) => {
  for (let i = 0; i < deskingOfferIds.length; i += 1) {
    const deskingOfferId = deskingOfferIds[i].trim();
    if (!(deskingOfferId in paymentCalcInProgress)) {
      paymentCalcInProgress[deskingOfferId] = 0;
    }
    paymentCalcInProgress[deskingOfferId] += 1;
  }

  return { ...paymentCalcInProgress };
};

const removeRequestInProgress = (
  paymentCalcInProgress,
  deskingOfferIds = [] /* string[] */,
) => {
  for (let i = 0; i < deskingOfferIds.length; i += 1) {
    const deskingOfferId = deskingOfferIds[i].trim();
    if (!(deskingOfferId in paymentCalcInProgress)) {
      paymentCalcInProgress[deskingOfferId] = 0;
    }
    paymentCalcInProgress[deskingOfferId] -= 1;
  }
  return { ...paymentCalcInProgress };
};

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.DESKINGOFFERPAYMENT_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.DESKINGPAYMENTS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('payments', payload);
    case types.DESKINGOFFERPAYMENT_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('payments', updateWithPayment(state.get('payments'), payload));
    case types.DESKINGOFFERPAYMENT_DELETE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('payments', deletePayment(state.get('payments'), payload));
    case types.DESKINGBULKPAYMENT_SUCCESS: {
      const deskingOfferId = payload.payment.deskingOfferId;
      const latestRequestDate = getLatestRequestDate(
        state.get('latestRequestDate'),
        deskingOfferId,
      );
      const requestDate = payload.requestDate;
      // process the response only if the request date matches the latest request data
      if (latestRequestDate.getTime() === requestDate.getTime()) {
        return state
          .set(constants.ERROR_KEY, null)
          .set(constants.FETCHING_KEY, false)
          .set(
            'payments',
            updateWithPayment(state.get('payments'), payload.payment),
          );
      }
      return state;
    }
    case types.DESKINGPAYMENTS_FAILURE:
    case types.DESKINGOFFERPAYMENT_FAILURE:
    case types.DESKINGOFFERPAYMENT_DELETE_FAILURE:
    case types.DESKINGBULKPAYMENT_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.DESKINGOFFERPAYMENT_CALC_START:
      return state.set(
        'paymentCalcInProgress',
        addRequestInProgress(state.get('paymentCalcInProgress'), payload),
      );
    case types.DESKINGOFFERPAYMENT_CALC_END:
      return state.set(
        'paymentCalcInProgress',
        removeRequestInProgress(state.get('paymentCalcInProgress'), payload),
      );
    case types.SET_LATEST_REQUEST_DATE:
      return state.set(
        'latestRequestDate',
        setLatestRequestDate(
          state.get('latestRequestDate'),
          payload.deskingOfferIds,
          payload.requestDate,
        ),
      );
    default:
      return state;
  }
};
